Utworzono
<a [routerLink]="['lookbook', 'edit', details.lookBookId, 'events']"
  >LookBook</a
>
dla
{{ ob | objectLabel: details.organizationClientId | async }}
